<template>
  <el-dialog
    :title="mode === 'create' ? '创建培训任务' : '编辑培训任务'"
    :visible.sync="dialogVisible"
    width="800px"
    @close="handleClose"
    append-to-body
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="培训标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入培训标题" />
      </el-form-item>

      <el-form-item label="培训分类" prop="category">
        <el-select v-model="form.category" placeholder="请选择分类" style="width: 100%">
          <el-option
            v-for="category in categoryOptions"
            :key="category.value"
            :label="category.label"
            :value="category.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="培训资料" prop="materialsId">
        <div class="materials-section">
          <el-button type="primary" @click="handleSelectMaterials">
            {{ selectedMaterials ? "已选择资料" : "选择培训资料" }}
          </el-button>

          <div v-if="selectedMaterials" class="selected-materials">
            <div class="materials-info">
              <span class="materials-title">{{ selectedMaterials.title }}</span>

              <el-tag size="mini" style="margin-left: 8px">
                {{ selectedMaterials.category }}
              </el-tag>
              <el-button
                size="mini"
                type="text"
                @click="handleClearMaterials"
                style="margin-left: 8px"
              >
                清除
              </el-button>
            </div>
            <div class="materials-desc">{{ selectedMaterials.description }}</div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="考试题目" prop="examId">
        <div class="exam-section">
          <el-button type="primary" @click="handleSelectExam">
            {{ selectedExam ? "已选择考试" : "选择考试题目" }}
          </el-button>

          <div v-if="selectedExam" class="selected-exam">
            <div class="exam-info">
              <span class="exam-title">{{ selectedExam.title }}</span>
              <el-tag size="mini" style="margin-left: 8px">
                {{ selectedExam.questions ? selectedExam.questions.length : 0 }}题
              </el-tag>
              <el-button size="mini" type="text" @click="handleClearExam" style="margin-left: 8px">
                清除
              </el-button>
            </div>
            <div class="exam-score">
              总分: {{ selectedExam.totalScore }}分 | 及格分: {{ selectedExam.passScore }}分
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="优先级" prop="priority">
        <el-input-number
          v-model="form.priority"
          :min="1"
          :max="10"
          placeholder="优先级"
          style="width: 200px"
        />
        <span style="margin-left: 10px; color: #909399">数值越大优先级越高</span>
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注信息（可选）"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="confirmLoading"> 确定 </el-button>
    </div>

    <!-- 选择资料对话框 -->
    <MaterialsSelectorDialog
      :visible.sync="materialsSelectorVisible"
      @confirm="handleMaterialsSelected"
    />

    <!-- 选择考试对话框 -->
    <ExamSelectorDialog :visible.sync="examSelectorVisible" @confirm="handleExamSelected" />
  </el-dialog>
</template>

<script>
import MaterialsSelectorDialog from "./MaterialsSelectorDialog.vue";
import ExamSelectorDialog from "./ExamSelectorDialog.vue";
import { BaseDataService } from "@/service/base-data-service";
import { saveTraining } from "@/api/new_training";
export default {
  name: "TrainingDialog",
  components: {
    MaterialsSelectorDialog,
    ExamSelectorDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: "create" // create | edit
    }
  },
  data() {
    return {
      dialogVisible: false,
      confirmLoading: false,
      form: {
        title: "",
        category: "",
        materialsId: "",
        examId: "",
        priority: 1,
        remark: ""
      },
      rules: {
        title: [{ required: true, message: "请输入培训标题", trigger: "blur" }],
        category: [{ required: true, message: "请选择培训分类", trigger: "change" }],
        examId: [{ required: true, message: "请选择考试题目", trigger: "change" }]
      },

      // 选择器对话框
      materialsSelectorVisible: false,
      examSelectorVisible: false,

      // 分类选项
      categoryOptions: BaseDataService.trainingCategoryOpts(),

      selectedExam: null,
      selectedMaterials: null
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.initForm();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 初始化表单
    initForm() {
      if (this.mode === "create") {
        this.form = {
          title: "",
          category: "",
          materialsId: "",
          examId: "",
          priority: 1,
          remark: ""
        };
      } else {
        this.form = { ...this.formData };
        this.selectedMaterials = this.formData.trainMaterials;
        this.selectedExam = this.formData.trainExam;
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    // 选择培训资料
    handleSelectMaterials() {
      this.materialsSelectorVisible = true;
    },

    // 选择考试题目
    handleSelectExam() {
      this.examSelectorVisible = true;
    },

    // 资料选择确认
    handleMaterialsSelected(materials) {
      this.form.materialsId = materials.id;
      this.selectedMaterials = materials;
    },

    // 考试选择确认
    handleExamSelected(exam) {
      this.form.examId = exam.id;
      this.selectedExam = exam;
    },

    // 清除资料
    handleClearMaterials() {
      this.form.materialsId = "";
      this.selectedMaterials = null;
    },

    // 清除考试
    handleClearExam() {
      this.form.examId = "";
      this.selectedExam = null;
    },

    // 确认
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.confirmLoading = true;
          try {
            const data = { ...this.form };
            await saveTraining(data);
            this.$emit("confirm", data);
            this.handleClose();
          } catch (error) {
            this.$message.error("保存失败");
            console.error(error);
          } finally {
            this.confirmLoading = false;
          }
        }
      });
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style lang="less" scoped>
.materials-section,
.exam-section {
  .selected-materials,
  .selected-exam {
    margin-top: 12px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;

    .materials-info,
    .exam-info {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      .materials-title,
      .exam-title {
        font-weight: 600;
        color: #303133;
      }
    }

    .materials-desc,
    .exam-score {
      color: #606266;
      font-size: 14px;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
